import type { ThemeId } from '@whistler-ui/k2/constants/global';
import { THEME_IDS } from '@whistler-ui/k2/constants/global';

import { csgConfig } from './csg';
import { gdConfig } from './gd';
import { gsmaConfig } from './gsma';
import { netlyncConfig } from './netlync';
import type { Config } from './types/brands';

export * from './csg';
export * from './gd';
export * from './gsma';
export * from './netlync';

const BRAND_CONFIGS: Record<string, Config> = {
  csgConfig,
  gdConfig,
  gsmaConfig,
  netlyncConfig,
};

const THEME_ID_VALUES: string[] = Object.values(THEME_IDS);

export function isThemeId(value: unknown): value is ThemeId {
  if (typeof value !== 'string') {
    return false;
  }

  return THEME_ID_VALUES.includes(value);
}

export function resolveBrandConfig(themeId: ThemeId): Config {
  return BRAND_CONFIGS[`${themeId}Config`] ?? netlyncConfig;
}
